import { render } from "./Payment.vue?vue&type=template&id=322f15bc"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "322f15bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('322f15bc', __exports__)) {
    api.reload('322f15bc', __exports__)
  }
  
  module.hot.accept("./Payment.vue?vue&type=template&id=322f15bc", () => {
    api.rerender('322f15bc', render)
  })

}


export default __exports__